// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__O7pxi","title":"Info_title__8QZjD","selects":"Info_selects__2tL3i","requiredAsterisk":"Info_requiredAsterisk__38Pw3"};